var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('figure',{staticClass:"prv-tooltip",class:_vm.classObject,attrs:{"data-content":_vm.content}},[_c('img',{attrs:{"src":"assets/icon-info-blue.svg","alt":"tooltip"}})])}
var staticRenderFns = []

export { render, staticRenderFns }